<template>
  <div class="page-wrap">
    <div class="wrap clearfix">
      <div class="form-box fr">
        <div v-if="curTab == 'resetpwd'">
          <reset-pwd
            :ncParams.sync="ncParams"
            @resetNc="resetSlideVerify"
            @success="loginSuccess"
          />
        </div>
        <div v-else>
          <ul class="form-tab clearfix">
            <li
              v-for="tab of tabs"
              :key="tab.name"
              class="tab-li"
              :class="[curTab == tab.name ? 'cur' : '']"
            >
              <a
                href="javascript:;"
                @click="curTab = tab.name"
                v-html="tab.text"
              ></a>
            </li>
          </ul>
          <div class="form-con">
            <!-- 登录 form -->
            <login-form
              :ncParams.sync="ncParams"
              :isSmsVerify="isSmsVerify"
              @resetNc="resetSlideVerify"
              @success="loginSuccess"
              v-if="curTab == 'login'"
            />
            <!-- 注册 form -->
            <reg-form
              :ncParams.sync="ncParams"
              @resetNc="resetSlideVerify"
              @success="loginSuccess"
              v-else-if="(curTab = 'reg')"
            />
          </div>
        </div>
        <div class="change-tip" @click="changeForm" v-text="chengeTip"></div>
      </div>
    </div>
  </div>
</template>
<script>
import NoCaptcha from 'NoCaptcha'
import {
  getUrlQueryVar,
  getNowTimestamp,
  createRandomStr,
  jumpOutUrl,
} from '@/libs/util.js'
import LoginForm from '@/components/Pc/LoginForm.vue'
import RegForm from '@/components/Pc/RegForm.vue'
import ResetPwd from '@/components/Pc/ResetPwd.vue'
import { commonParams, hsqAppid } from '@/libs/commonParamsStore.js'

export default {
  name: 'PcMain',
  components: { LoginForm, RegForm, ResetPwd },
  data() {
    return {
      initd: false,
      curTab: 'login',
      ncParams: {
        prefixToken: 'abadslafjasajf',
        appkey: '',
        scene: '',
        is_nc: false,
        renderTo: {
          login: '#np-verify-login',
          reg: '#np-verify-reg',
          resetpwd: '#np-verify-resetpwd',
        },
        token: '',
        sig: '',
        session: '',
        createdAt: 0,
      },
      commonParams,
      redirectUrl: '',
      isSmsVerify: false
    }
  },
  computed: {
    chengeTip() {
      if (this.curTab == 'resetpwd') {
        return '返回账号登录>>'
      } else {
        return '忘记密码？'
      }
    },
    tabs() {
      if (commonParams.sys.isGum || commonParams.sys.isGys) {
        return [{ name: 'login', text: '平台登录' }]
      } else {
        return [
          { name: 'login', text: '登录' },
          { name: 'reg', text: '注册' },
        ]
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    // 重置滑块
    async resetSlideVerify() {
      if (this.curTab == 'login' && !this.ncParams.is_nc) {
        return
      }
      await this.initNcParam()
      let nc_token = [this.ncParams.prefixToken, createRandomStr()].join(':')
      this.ncParams.token = ''
      let nc = NoCaptcha.init({
        //声明滑动验证需要渲染的目标元素ID。
        renderTo: this.ncParams.renderTo[this.curTab],
        //应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
        appkey: this.ncParams.appkey,
        //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
        scene: this.ncParams.scene,
        //滑动验证码的主键，请勿将该字段定义为固定值。确保每个用户每次打开页面时，其token值都是不同的。系统默认的格式为：”您的appkey”+”时间戳”+”随机数”。
        token: nc_token,
        //业务键字段，可为空。为便于线上问题的排查，建议您按照线上问题定位文档中推荐的方法配置该字段值。
        // trans: {"key1": "code0"},
        //语言，默认值为cn（中文）。HTML5应用类型默认支持简体中文、繁体中文、英文语言。
        // language: "cn",
        //内部网络请求的超时时间。一般情况建议保持默认值（10000ms）。
        // timeout: 10000,
        //允许服务器超时重复次数，默认5次。
        // retryTimes: 5,
        //验证通过后，验证码组件是否自动隐藏，默认不隐藏（false）。
        bannerHidden: false,
        //是否默认不渲染，默认值false。当设置为true时，不自动渲染，需要自行调用show方法进行渲染。
        initHidden: false,
        //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
        callback: (data) => {
          this.ncParams.token = nc_token
          this.ncParams.sig = data.sig
          this.ncParams.session = data.csessionid
        },
        error: () => {
          this._warning('校验失败，请重试')
          this.resetSlideVerify()
        },
      })
      NoCaptcha.setEnabled(true)
      NoCaptcha.upLang('cn', {
        LOADING: '验证中...', //加载
        SLIDER_LABEL: '请向右滑动验证', //等待滑动
        CHECK_Y: '验证通过', //通过
        ERROR_TITLE: '校验失败，请重试', //拦截
      })
      //请务必在此处调用一次reset()方法。
      nc.reset()
    },
    // 初始化滑块需要的参数
    async initNcParam() {
      if (
        this.ncParams.createdAt &&
        getNowTimestamp() - this.ncParams.createdAt <= 600
      ) {
        return
      }
      let data = await this.$apis.initNc()
      this.ncParams.appkey = data.app_key
      this.ncParams.scene = data.scene
      this.ncParams.prefixToken = data.prefix_token
      this.ncParams.createdAt = getNowTimestamp()
    },
    async init() {
      let dwd_appid = getUrlQueryVar('appId')
      let sub_appid = getUrlQueryVar('subAppid')
      let redirect_url = getUrlQueryVar(
        'redirectUrl',
        getUrlQueryVar('redirectURL')
      )
      if (redirect_url) {
        redirect_url = decodeURIComponent(redirect_url)
      } else {
        redirect_url = decodeURIComponent(getUrlQueryVar('referer'))
      }
      if (redirect_url && redirect_url.includes('token=')) {
        redirect_url = redirect_url.replace(/(&?token=[A-Za-z0-9]+)/g, '')
      }

      let token = this.commonParams.state.token
      this.redirectUrl = redirect_url
      let initParams = { dwd_appid, token, redirect_url,sub_appid }
      if (window.location.pathname.includes('logout')) {
        initParams['logout'] = 1
      }
      let data = await this.$apis.init(initParams, null, (ret) => {
        if (ret.errno == 800001) {
          this.initFail('网址错误,请检查网址是否正确')
        } else {
          this.initFail('服务器异常，请稍后刷新重试')
        }
        this.commonParams.initSys()
        return true
      })
      if (!data) {
        return
      }
      if (!data.dwd_appid) {
        this.initFail('缺少业务线参数')
        return
      }
      this.commonParams.setDwdAppidAction(data.dwd_appid)
      if (initParams['logout'] && data.dwd_appid == hsqAppid) {
        if (getUrlQueryVar('subAppid') != 'admin') {
          this.$router.push({ name: 'welcome' })
          return
        }
      }
      this.initd = true
      if (typeof data['is_nc'] != 'undefined') {
        this.ncParams.is_nc = data['is_nc']
        if (typeof data['nc_params'] != 'undefined') {
          this.ncParams.prefixToken = data.nc_params.prefix_token
          this.ncParams.appkey = data.nc_params.app_key
          this.ncParams.scene = data.nc_params.scene
          this.ncParams.createdAt = getNowTimestamp()
        }
      }
      this.isSmsVerify = data['is_sms_verify']
      if (data.token) {
        this.commonParams.setTokenAction(data.token)
      }
      if (data.sso_token) {
        this.loginSuccess({
          sso_token: data.sso_token,
          sso_username: data.sso_username,
          direct: false,
        })
        return
      }
      this.resetSlideVerify()
    },
    initFail(msg) {
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(() => {})
        .catch(() => {})
    },
    loginSuccess(data) {
      const ssoToken = data.sso_token
      let url = ''
      if (this.redirectUrl.includes('?')) {
        url = `${this.redirectUrl}&token=${ssoToken}`
      } else {
        url = `${this.redirectUrl}?token=${ssoToken}`
      }
      const lastLoginAtKey = `passportLastLogin_${this.commonParams.dwd_appid}`
      if (!data.direct) {
        // 防止重复跳转
        const lastLoginAt = localStorage.getItem(lastLoginAtKey)
        if (lastLoginAt && getNowTimestamp() - lastLoginAt < 10) {
          // 显示确认点击登录
          this.$confirm(`<h3>${data.sso_username}</h3>`, '是否继续登录', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
            center: true,
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
          })
            .then(() => {
              localStorage.setItem(lastLoginAtKey, getNowTimestamp())
              jumpOutUrl(url)
            })
            .catch(() => {})
          return
        }
      }
      localStorage.setItem(lastLoginAtKey, getNowTimestamp())
      jumpOutUrl(url)
    },
    changeForm() {
      if (this.curTab == 'resetpwd') {
        this.curTab = 'login'
      } else {
        this.curTab = 'resetpwd'
      }
    },
  },
  watch: {
    curTab() {
      this.$nextTick(() => {
        this.resetSlideVerify()
      })
    },
  },
}
</script>

<style></style>
